import { creditScoreGetters } from '@/store/modules/creditScore/routines'

export default {
  [creditScoreGetters.CREDIT_SCORE_DETAILS]: state => state.creditScoreDetails
}
